var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 15,
    viewBox: "0 0 72 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.3719,
    height: 14.2222,
    fill: "#379858",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40625 6.71281e-05L3.55556 0L4.18409 0.628539L1.77778 3.03486V11.1874L4.18409 13.5937L3.55556 14.2222H2.40625L0 11.9237V2.29848L2.40625 6.71281e-05Z",
    fill: "#379858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85071 10.0356V4.18673L8.28182 2.75562H12.5378L13.944 4.16184V5.49339H12.2516V4.78406L11.6667 4.19917H9.17782L8.54315 4.83384V9.3885L9.17782 10.0232H11.6667L12.2516 9.43828V8.72895H13.944V10.0605L12.5378 11.4667H8.28182L6.85071 10.0356Z",
    fill: "#4AD479"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 10.0356V4.18673L17.4319 2.75562H21.9119L23.343 4.18673V10.0356L21.9119 11.4667H17.4319L16.0008 10.0356ZM21.0159 10.0232L21.6506 9.3885V4.83384L21.0159 4.19917H18.3279L17.6932 4.83384V9.3885L18.3279 10.0232H21.0159Z",
    fill: "#4AD479"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8343 2.75562H27.4023L29.9908 8.3805H30.0157L32.6165 2.75562H34.1845V11.4667H32.5543V6.16539H32.5294L30.5259 10.2472H29.4805L27.4894 6.16539H27.4645V11.4667H25.8343V2.75562Z",
    fill: "#4AD479"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7952 2.75562H38.3632L40.9516 8.3805H40.9765L43.5774 2.75562H45.1454V11.4667H43.5152V6.16539H43.4903L41.4867 10.2472H40.4414L38.4503 6.16539H38.4254V11.4667H36.7952V2.75562Z",
    fill: "#4AD479"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6315 10.0356V4.18673L49.0627 2.75562H53.5427L54.9738 4.18673V10.0356L53.5427 11.4667H49.0627L47.6315 10.0356ZM52.6467 10.0232L53.2813 9.3885V4.83384L52.6467 4.19917H49.9587L49.324 4.83384V9.3885L49.9587 10.0232H52.6467Z",
    fill: "#4AD479"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4651 2.75562H58.9833L62.866 8.66673H62.8909V2.75562H64.5211V11.4667H63.0029L59.1202 5.56806H59.0953V11.4667H57.4651V2.75562Z",
    fill: "#4AD479"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9657 6.71281e-05L67.8164 0L67.1879 0.628539L69.5942 3.03486V11.1874L67.1879 13.5937L67.8164 14.2222H68.9657L71.3719 11.9237V2.29848L68.9657 6.71281e-05Z",
    fill: "#379858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonHover);
export default __webpack_public_path__ + "static/media/common-hover.43eb31cb9262a77a0b635f4b67f580e7.svg";
export { ForwardRef as ReactComponent };